import React from 'react';
import { TextCustom } from '../../../text';
import { Row, Col } from 'antd';
import { VERSION, color, LINE_FOOTER_ICON_URL } from '../../../../resources';

const styledTextCenter = { textAlign: 'center' }
const styledSectionFooter = { whiteSpace: 'nowrap', marginTop: '12px' }
const styledMarginRight16 = { marginRight: '16px' }

const menus = [
  {
    url: "https://applehouseth.com/",
    text: "ติดต่อสอบถามหรือแจ้งปัญหาการใช้งาน"
  },
  {
    url: "https://applehouseth.com/location/",
    text: "เช็กสาขาใกล้คุณ"
  },
  {
    url: "https://applehouseth.com/blog",
    text: "ข่าวสารและโปรโมชัน"
  },
  {
    url: "https://applehouseth.com/blog/",
    text: "คำถามที่พบบ่อย"
  },
  {
    url: "https://applehouseth.com/protection-policy/",
    text: "ข้อกำหนดและเงื่อนไขในการใช้เว็บไซต์"
  },
  {
    url: "https://applehouseth.com/private-note/",
    text: "นโยบายความเป็นส่วนตัว"
  },
  {
    url: "https://applehouseth.com/cookie/",
    text: "นโยบายคุกกี้"
  }
]

export const review = <><TextCustom text={`apple house บริการรับซื้อไอโฟน ไอแพด (iPhone iPad) ราคาสูง ประเมินราคาออนไลน์ฟรี รู้ผลไวภายใน 1 นาที ให้ราคาตามราคาตลาดจริง ไม่กดราคา ปลอดภัย ไม่โดนโกง ขายไอโฟนที่ไหนดี ขายกับ apple house มั่นใจได้ เพราะมีหน้าร้านตั้งอยู่ในศูนย์การค้าชั้นนำทั่วประเทศ พร้อมทำสัญญาซื้อ-ขายถูกต้องทุกครั้ง สบายใจทั้งผู้ซื้อและผู้ขาย รับซื้อไอโฟนมือสองทุกรุ่น ทุกสภาพ มีหน้าร้านจริงอยู่ห้างสรรพสินค้า มั่นใจได้ การันตีรับซื้อไอโฟน มามากกว่า 10,000 เครื่อง`} size="20px" align={"left"} color={color.white} /></>

export const listMedia = <div><TextCustom text={"ติดตามเรา"} size="24px" align={"left"} color={color.white} bold />
  <a href='https://www.facebook.com/byAppleHouse' style={styledMarginRight16}><img src={`../../../assets/icons/fb-w.svg`} alt="fb-icon" class="icon-media" /></a>
  <a href={LINE_FOOTER_ICON_URL} style={styledMarginRight16}><img src={`../../../assets/icons/line-w.svg`} alt="line-icon" class="icon-media" /></a>
  <a href='https://q.me-qr.com/ijuwsz3p' style={styledMarginRight16}><img src={`../../../assets/icons/tt-w.svg`} alt="tt-icon" class="icon-media" /></a>
  <a href='tel:0953194700' style={styledMarginRight16}><img src={`../../../assets/icons/phone-w.svg`} alt="phone-icon" class="icon-media" /></a>
  <a href='mailto:appleshouse@gmail.com' style={styledMarginRight16}><img src={`../../../assets/icons/mail-w.svg`} alt="mail-icon" class="icon-media" /></a></div>

export const listMenu = <>
  {menus.map((el, i) => {
    return <><a href={el.url} className='a-footer' key={`menu-${i}`} target='_blank'>{el.text}</a><br /></>
  })}
</>

export const itemsFooter2 = <><Row >
  <Col span={24} style={styledTextCenter}>
  <TextCustom text={VERSION} size="18px" />
  </Col></Row>
  <Row>
    <Col span={24} style={styledTextCenter}>
      <div style={styledSectionFooter}>
        <a href='#' className='text-footer2'>สงวนลิขสิทธิ์ © 2566</a>
        <a href='https://applehouseth.com/protection-policy/' className='text-footer2' target='_blank'>ข้อกำหนดและเงื่อนไขในการใช้เว็บไซต์</a>
        <a href='https://applehouseth.com/private-note/' className='text-footer2' target='_blank'>นโยบายความเป็นส่วนตัว</a>
        <a href='https://applehouseth.com/cookie/' className='text-footer2' target='_blank'>นโยบายคุกกี้</a></div>
    </Col>

  </Row>

</>

export const gutterDefault = { xs: 8, sm: 16, md: 24, lg: 32 }